import * as $ from 'jquery';
import 'datepicker';
import 'selectize';
import * as Cookies from 'js-cookie';
import { bookingFormBackend } from "./c005-bookingform-backend";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormCommon } from "./c005-bookingform-common";

export class bookingFormRedemption {
	private bookingFormBackend = new bookingFormBackend();
	private bookingFormSubmit = new bookingFormSubmit();
	private bookingFormCommon = new bookingFormCommon();

	$loginCookieName: string      = 'MAB-Enrich-LoginID';

	/**
	 * [initPaymentMethods description]
	 * @param  {any} scope [description]
	 */
	initPaymentMethods(scope:any): void {
		let payMethods = scope.find('input[name="cash_miles_type"]');
		let tripType   = scope.find('.trip-type--container');

		// initial load
		paymentTypeTriage();

		payMethods.click(function(){
			paymentTypeTriage();
		});

		tripType.click(function(){
			paymentTypeTriage();
		});

		/**
		 * payment method triage logic
		 * hide coupon code if:
		 * - triptype: multicity
		 * - paymentmethod: miles/cash&miles
		 * hide payment methods (miles/cash&miles) if:
		 * - triptype: multicity
		 */
		function paymentTypeTriage():void { 
			let type = scope.find('input[name="cash_miles_type"]:checked').val();
			if(type === 'cash') {
				if($('#isSideTripEmpty').val() === 'No') {
					let isSideTripEnabled = $('#isSideTripEnable').val();
					if (isSideTripEnabled === 'Yes') {
						scope.find('li.sideTrip').show();
						scope.find('li.ibe_sideTrip').show();
					} else {
						scope.find('li.sideTrip').hide();
						scope.find('li.ibe_sideTrip').hide();
					}					
				} else {
					scope.find('li.sideTrip').hide();
					scope.find('li.ibe_sideTrip').hide();
				}
				
			} else {
				scope.find('li.sideTrip').hide();
				scope.find('.sidetrippanel').hide();
				scope.find('li.ibe_sideTrip').hide();
				scope.find('.ibe_freesidetrip').hide();
			}
			if (tripType.find('.multiCityTrip').hasClass('selected')) {
				scope.find('.couponCode').hide();
				scope.find('input#rdmpayment__miles_desktop').parents().eq(1).fadeOut();
				scope.find('input#rdmpayment__cash_miles_desktop').parents().eq(1).fadeOut();
			} else {
				scope.find('input#rdmpayment__miles_desktop').parents().eq(1).fadeIn();
				scope.find('input#rdmpayment__cash_miles_desktop').parents().eq(1).fadeIn();
				couponCodeHandler(type);
			}
		}

		function couponCodeHandler(type:string):void {
			let $couponCodeEl:any        = scope.find('.couponcode-input');
			let $couponCodeContainer:any = scope.find('.couponCode').hide();

			switch (type) {
				case 'miles':
				case 'cash_miles': {
					$couponCodeContainer.hide();
					$couponCodeEl.attr('disabled', 'disabled');
					tripType.find('.multiCityTrip').fadeOut();
				}
				break;
				default: {
					let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
					let studentDashboard = document.querySelector('.student-dashboard');
					let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');
					let isMOT = false;
					if (studentEnrichIdCookieVal != null && studentDashboard != null) {
						if ($('#mab-bookingnav .navbar #bookingNav li.selected a').hasClass('flysiswa') ||
							$('#mab-bookingnav .navbar #bookingNav li.selected a').hasClass('mob-flysiswa')) {
								isMOT = true;
						}
					}
					if(!isMOT) {
						$couponCodeContainer.show();
					}
					if (athleteId != null) {
						$couponCodeContainer.hide();
					}				
					$couponCodeEl.removeAttr('disabled');
					tripType.find('.multiCityTrip').fadeIn();
				}
				break;
			}
		}
	}

	/**
	 * [initRdmLogin description]
	 * @param  {any}    scope                  [description]
	 * @param  {string} singleSubmitSelector   [description]
	 * @param  {string} multiSubmitSelector    [description]
	 * @param  {any}    fromLocationIdentifier [description]
	 */
	initRdmLogin(scope:any, singleSubmitSelector:string, multiSubmitSelector:string, fromLocationIdentifier:any, toLocationIdentifier:any): void {
		let _self = this;
		let loginStatus:boolean = false;
		let loginTokenCookieVal = document.cookie.match('(^|;)\\s*phantom\\s*=\\s*([^;]+)');
		if (loginTokenCookieVal != null) {
			loginStatus = true; // find login status here
		}

		let loginContainer = scope.find('.container--redemption-login');
		let loginFields    = loginContainer.find('input');

		let singleTripSubmitBtn:any = scope.find(singleSubmitSelector);
		let multiTripSubmitBtn:any  = scope.find(multiSubmitSelector);
		let rdmSingleSubmitBtn:any  = scope.find('.redemption-submit-btn-single');
		let rdmMultiSubmitBtn:any   = scope.find('.redemption-submit-btn-multi');

		let tripType   = scope.find('.trip-type--container');
		let payMethods = scope.find('input[name="cash_miles_type"]');
		let $errorValidation = scope.find('.error-validation').first();

		let $ibeRedemptionLoginID: any = scope.find('[data-ibe-redemption--login-id]');
		let $ibeRedemptionLoginPIN: any = scope.find('[data-ibe-redemption--login-pin]');

		$ibeRedemptionLoginID.bind('input', function(){
			$(this).val(function(_:any, v:any){
				return v.replace(/\s+/g, '');
			});
		});

		$ibeRedemptionLoginPIN.bind('input', function(){
			$(this).val(function(_:any, v:any){
				return v.replace(/\s+/g, '');
			});
		});

		// trigger event handlers for new submit buttons
		// hand off click event to existing submit buttons
		rdmSingleSubmitBtn.on('click', (e:any) => {
			let type = scope.find('input[name="cash_miles_type"]:checked').val();
			e.preventDefault();
			e.stopPropagation();
			$errorValidation.show();
			console.log(scope[0].id);
			let $ibeRedemptionLoginRemember:any = scope.find('[data-ibe-redemption--login-remember]');
			let $ibeRedemptionLoginID: any = scope.find('[data-ibe-redemption--login-id]');
			if($ibeRedemptionLoginRemember.is(':checked')){
				let $cookieIdValue: any = $ibeRedemptionLoginID.val();
				Cookies.set(_self.$loginCookieName, $cookieIdValue);
			} else {
				Cookies.set(_self.$loginCookieName, '');
			}
			if (scope[0].hasAttribute('data-ibe--book-flight')) {
				let $instance:any = $(scope);
				console.log('desktop form');
				_self.bookingFormSubmit.singleBookingFormValidation($instance, scope.$officeCode, function ($officeCode:any) {
					_self.bookingFormBackend.loginAndBookFlightSubmitHandler(scope, type, loginStatus);
				});
			} else if (scope[0].hasAttribute('data-mob-ibe--book-flight')) {
				let $instance:any = $(scope);
				console.log('mobile form');
				_self.bookingFormSubmit.mobileBookingFormValidation($instance, scope.$officeCode, function($officeCode:any){
					_self.bookingFormBackend.loginAndBookFlightSubmitHandler(scope, type, loginStatus);
				});
			}
		});

		rdmMultiSubmitBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();
			multiTripSubmitBtn.click();
		});

		// run loginSubFormHandler() on load
		// declare true (logged in) to hide login fields on load since cash payment is default option for ibe
		loginSubFormHandler(true,"");

		// run loginSubFormHandler() on each payment method change
		payMethods.click(function(){
			let type = scope.find('input[name="cash_miles_type"]:checked').val();
			let toLocationSelectize:any = scope.find('select'+toLocationIdentifier)[0].selectize;
			let fromLocationSelectize:any = scope.find('select'+fromLocationIdentifier)[0].selectize;

			/* Clearing date values as per #2251 comments recieved */
			if($('#search_recentpayment').length<1)
			{
			scope.find('.departureDate').val('');
			scope.find('.returnDate').val('');
			scope.find('.departureDateMobile ').val('');
			scope.find('.returnDateMobile').val('');
			}
			switch (type) {
				case 'miles':
				case 'cash_miles':
					let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
					let sapphireCookieExist:boolean = false;
					if (loginTokenCookieVal != null) {
						sapphireCookieExist = true; // find login status here
					}
					loginSubFormHandler(sapphireCookieExist,type);
					// toggle redemption button class
					singleTripSubmitBtn.addClass('redemption-submit-btn-single redemption--bookflight');
					singleTripSubmitBtn.removeClass('single-city--bookflight');
					singleTripSubmitBtn.off();
					// if desktop form
					if (scope[0].hasAttribute('data-ibe--book-flight')) {
						singleTripSubmitBtn.off('click').on('click', function (e: any) {
							e.preventDefault();
							e.stopPropagation();
							$errorValidation.show();
							let $instance: any = $(scope);
							let desktopOfficeCode = _self.desktopOfficeCode($instance);
							_self.bookingFormSubmit.singleBookingFormValidation($instance, desktopOfficeCode, function ($officeCode: any) {
								_self.bookingFormBackend.loginAndBookFlightSubmitHandler(scope, type, loginStatus);
							});
						});
						// if mobile form
					} else if (scope[0].hasAttribute('data-mob-ibe--book-flight')) {
						singleTripSubmitBtn.off('click').on('click', function (e: any) {
							e.preventDefault();
							e.stopPropagation();
							let $instance: any = $(scope);
							let mobileOfficeCode = _self.mobileOfficeCode($instance);
							_self.bookingFormSubmit.mobileBookingFormValidation($instance, mobileOfficeCode, function ($officeCode: any) {
								_self.bookingFormBackend.loginAndBookFlightSubmitHandler(scope, type, loginStatus);
							});
						});						
						let $fromLocationMobileInput: any = scope.find('.ibe-mob-from--location-input');
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.removeClass('input-filled');
						$fromLocationMobileInput.html('<div></div>');
						let $toLocationMobileInput: any = scope.find('.ibe-mob-to--location-input');
						let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
						$toLocationMobTitle.removeClass('input-filled');
						$toLocationMobileInput.html('<div></div>');
					}	
					if($('#search_recentpayment').length<1)
					{
						fromLocationSelectize.clear(true);
						toLocationSelectize.clear(true);
						_self.bookingFormCommon.updateAirportOnDListOnFlowChangeNew("Redemption", '', scope.find('select' + fromLocationIdentifier));
						_self.bookingFormCommon.updateAirportOnDListOnFlowChangeNew("Redemption", '', scope.find('select' + toLocationIdentifier));
						// clear to location as well (clear silently)
						toLocationSelectize.clear(true);
						toLocationSelectize.trigger('blur');
						fromLocationSelectize.clear(true);					
						fromLocationSelectize.trigger('blur');
						let $cabinClass: any = $('.ibe-form--container').find('.cabin-class');
						$cabinClass[0].selectize.setValue("CFFECO");	
						let $cabinClassmob: any = $('.ibe-form--container').find('.cabin-class-mob');
						$cabinClassmob[0].selectize.setValue("CFFECO");	
					}
				break;
				default:
					loginSubFormHandler(true,"");	
					let singleTripSubmitSideTripBtn:any =	scope.find('.mobile-search-nofst-form-submit');			
					singleTripSubmitSideTripBtn.addClass('single-city--bookflight');
					singleTripSubmitBtn.addClass('single-city--bookflight');
					singleTripSubmitBtn.removeClass('redemption-submit-btn-single redemption--bookflight');
					singleTripSubmitBtn.off();
					// if desktop form
					if (scope[0].hasAttribute('data-ibe--book-flight')) {
						singleTripSubmitBtn.off('click').on('click', function (evt:any) {
							evt.preventDefault();
							$errorValidation.show();
							let $instance:any = $(scope);
							let desktopOfficeCode = _self.desktopOfficeCode($instance);
							_self.bookingFormSubmit.singleBookingFormValidation($instance, desktopOfficeCode, function ($officeCode:any) {
								if (_self.bookingFormSubmit.DesktopSidetripEligibilityCheck($instance)) {
									$('.ibe_freesidetrip').show();
									$('.single-city--bookflight').hide();
									_self.bookingFormSubmit.singleBookingFormSubmit($instance, '', '', '', $officeCode);
								} else {
									$('.ibe_freesidetrip').hide();
									_self.bookingFormSubmit.singleBookingFormSubmit($instance, '', '', '', $officeCode);
								}	
							});
						});
					// if mobile form
					} else if (scope[0].hasAttribute('data-mob-ibe--book-flight')) {
						singleTripSubmitBtn.off('click').on('click', function (e: any) {
							e.preventDefault();
							e.stopPropagation();
							let $instance: any = $(scope);
							let mobileOfficeCode = _self.mobileOfficeCode($instance);
							_self.bookingFormSubmit.mobileBookingFormValidation($instance, mobileOfficeCode, function ($officeCode: any) {
							/*	let isSideTripEnabled = $('#isSideTripEnable').val();
								if (isSideTripEnabled === 'Yes') {
									if (_self.bookingFormSubmit.mobileSidetripEligibilityCheck($instance)) {
										$instance.find('.sidetrippanel').show();
										$instance.find('.mobile-search-form-submit').hide();
									} else {
										$instance.find('.sidetrippanel').hide();
										$instance.find('.mobile-search-form-submit').show();										
										_self.bookingFormSubmit.mobileBookingFormSubmit($instance, '', '', '', $officeCode);
									}
								} else {
									*/
									$instance.find('.sidetrippanel').hide();
									$instance.find('.mobile-search-form-submit').show();									
									_self.bookingFormSubmit.dxBookingFormSubmit($instance, '', '', '', $officeCode);
								//}

							});
						});
						singleTripSubmitSideTripBtn.off('click').on('click', function (e:any) {
							e.preventDefault();
							e.stopPropagation();
							let $instance:any = $(scope);
							let mobileOfficeCode = _self.mobileOfficeCode($instance);
							_self.bookingFormSubmit.mobileBookingFormValidation($instance, mobileOfficeCode, function($officeCode:any){
								_self.bookingFormSubmit.dxBookingFormSubmit($instance, '', '', '', $officeCode);
							});
						});
						let $fromLocationMobileInput: any = scope.find('.ibe-mob-from--location-input');
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.removeClass('input-filled');
						$fromLocationMobileInput.html('<div></div>');
						let $toLocationMobileInput: any = scope.find('.ibe-mob-to--location-input');
						let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
						$toLocationMobTitle.removeClass('input-filled');
						$toLocationMobileInput.html('<div></div>');
					}
					if($('#search_recentpayment').length<1)
					{
					fromLocationSelectize.clear(true);
					toLocationSelectize.clear(true);
					_self.bookingFormCommon.updateAirportOnDListOnFlowChangeNew("Revenue", '', scope.find('select'+fromLocationIdentifier));
					_self.bookingFormCommon.updateAirportOnDListOnFlowChangeNew("Revenue", '', scope.find('select' + toLocationIdentifier));
					// clear to location as well (clear silently)
					toLocationSelectize.clear(true);
					toLocationSelectize.trigger('blur');
					fromLocationSelectize.clear(true);
					fromLocationSelectize.trigger('blur');
					let $cabinClass: any = $('.ibe-form--container').find('.cabin-class');
					$cabinClass[0].selectize.setValue("CFFECO");	
					let $cabinClassmob: any = $('.ibe-form--container').find('.cabin-class-mob');
					$cabinClassmob[0].selectize.setValue("CFFECO");	
					}
				break;
			}
		});

		tripType.click(function(){
			let type = scope.find('input[name="cash_miles_type"]:checked').val();
			switch (type) {
				case 'miles':
				case 'cash_miles':
				loginSubFormHandler(loginStatus,type);
				// toggle redemption button class
				singleTripSubmitBtn.addClass('redemption-submit-btn-single redemption--bookflight');
				singleTripSubmitBtn.removeClass('single-city--bookflight');
				break;
				default:
				loginSubFormHandler(true,"");
				singleTripSubmitBtn.addClass('single-city--bookflight');
				singleTripSubmitBtn.removeClass('redemption-submit-btn-single redemption--bookflight');
				break;
			}
		});

		function loginSubFormHandler(state:boolean,type:string) {
			if (state) {
				// user logged in
				// console.log('%credemption%c user logged in', 'background-color: green; color: white', 'background-color: initial; color: black');
				loginContainer.css('display', '');
				loginContainer.addClass('hidden');
				if (tripType.find('.multiCityTrip').hasClass('selected')) {
					singleTripSubmitBtn.hide();
					multiTripSubmitBtn.show();
				} else {
					
				if(!($('.ibe_freesidetrip').is(":visible")||($('.sidetrippanel').is(":visible")))) 
					{
						singleTripSubmitBtn.show();
					}
		
					multiTripSubmitBtn.hide();
				}
				loginFields.each(function() {
					$(this).attr('disabled', 'disabled');
				});
				return true;
			} else {
				// user not logged in
				// console.log('%credemption%c user not logged in', 'background-color: red; color: white', 'background-color: initial; color: black');
				/*loginContainer.css('display', 'block');
				loginContainer.removeClass('hidden');
				singleTripSubmitBtn.hide();
				multiTripSubmitBtn.hide();
				loginFields.each(function() {
					$(this).removeAttr('disabled');
				});*/
				if(type==='cash_miles')
				{
					let $earlyLoginUrl: any	=	$('#earlyLoginUrl');
					if (($earlyLoginUrl.val()!='null') && ($earlyLoginUrl.val()!='')) {
						window.location.href = $earlyLoginUrl.val();
					}

				}else{
					let $earlyMilesLoginUrl: any	=	$('#earlyMilesLoginUrl');
					if (($earlyMilesLoginUrl.val()!='null') && ($earlyMilesLoginUrl.val()!='')) {
						window.location.href = $earlyMilesLoginUrl.val();
					}
				}
				
				return false;
			}
		}
	}

	/**
	 * [desktopOfficeCode description]
	 * @return {string} [description]
	 */
	desktopOfficeCode($instance:any): string {
		let $selected = $instance.find('.fromLocation').find(":selected");
		let $selected_text = $selected.text();
		let $fromOfficeID: any;
		if ($selected_text.includes('|')) {
			if ($selected_text.split('|')[0] === 'Recent') {
				$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
			} else {
				$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
			}
		} else {
			$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
		}		
		return $fromOfficeID;
	}

	/**
	 * [mobileOfficeCode description]
	 * @return {string} [description]
	 */
	mobileOfficeCode($instance:any): string {
		let $selected = $instance.find('.ibe-mob-from--location').find(":selected");
		let $selected_text = $selected.text();
		let $fromOfficeID: any;
		if ($selected_text.includes('|')) {
			if ($selected_text.split('|')[0] === 'Recent') {
				$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
			} else {
				$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
			}
		} else {
			$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
		}
		return $fromOfficeID;
	}
}
